import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { useAtom } from 'jotai';
// routes
import { PATH_CUSTOMER, PATH_AUTH } from '../../shared/routes/paths';
// state
import { userRecordAtom } from '../../shared/state/atoms';

// ----------------------------------------------------------------------

GuestGuard.propTypes = {
  children: PropTypes.node,
};

export default function GuestGuard({ children }) {
  const [user] = useAtom(userRecordAtom);

  if (user) {
    if (!user.isEnabled) {
      return <Navigate to={PATH_AUTH.landing} replace />;
    }
    return <Navigate to={PATH_CUSTOMER.dashboard} replace />;
  }

  return <>{children}</>;
}
